'use client';

import { useSharedModalAdapterOptional } from '@module/helpers/modal/adapter';
import type { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import { useRouter } from 'next/navigation';
import { useRef } from 'react';

/**
 * loginMust 에러의 공통 정책 조각: 로그인 유도 확인 모달 + 닫으면 홈으로 이동.
 * 로그아웃 등으로 여러 쿼리가 동시에 loginMust로 실패해도 모달이 중복 push되지 않게 dedup한다.
 *
 * 이 훅은 "정책"만 제공한다. 어떤 code에 이걸 붙일지(switch 조립)는 각 앱의 등록부가 소유한다.
 * → 앱별로 다른 에러 처리는 각 앱에 격리되고, 공용 모듈은 진짜 공통 로직만 갖는다.
 */
export function useLoginMustHandler({
  confirmText
}: {
  confirmText: string;
}) {
  const router = useRouter();
  const modalAdapter = useSharedModalAdapterOptional();
  const adapterRef = useRef(modalAdapter);
  adapterRef.current = modalAdapter;
  const isOpenRef = useRef(false);
  return (error: BaseHttpResponseError) => {
    if (isOpenRef.current) return;
    if (!adapterRef.current) return;
    isOpenRef.current = true;
    adapterRef.current.showConfirm({
      description: error.serverResponse.message,
      confirmText,
      onClose: () => {
        adapterRef.current?.clear();
        router.push('/');
      }
    }).finally(() => {
      isOpenRef.current = false;
    });
  };
}